async function fetchLatestReleaseInfo() {
  try {
    // We need to always fetch the latest release info in order to get the latest build id
    // but we don't want to see the cached version in the browser
    // So we have a timestamp so we never read from cache
    const fetchReleaseInfo = await fetch(`/assets/release-info.json?timestamp=${new Date().getTime()}`)
    const releaseInfo: SofiaVersion = await fetchReleaseInfo.json()
    return releaseInfo
  } catch {
    throw new Error("Error fetching release info")
  }
}

export { fetchLatestReleaseInfo }
